<nb-card>
	<nb-card-header class="d-flex">
		<h5>{{ 'USERS_PAGE.ADD_USER' | translate }}</h5>
		<nb-icon
			class="ml-auto mt-1 close"
			icon="close-outline"
			(click)="closeDialog()"
		></nb-icon>
	</nb-card-header>
	<nb-card-body>
		<ga-user-basic-info-form
			[isSuperAdmin]="isSuperAdmin"
			#userBasicInfo
		></ga-user-basic-info-form>
	</nb-card-body>
	<nb-card-footer class="text-right">
		<button
			[disabled]="userBasicInfo.form.invalid"
			status="success"
			(click)="add()"
			nbButton
		>
			{{ 'USERS_PAGE.ADD_USER' | translate }}
		</button>
	</nb-card-footer>
</nb-card>
